import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import { Swiper, SwiperSlide } from "swiper/react"

import Button from "../Button"

import {
  Section,
  Wrapper,
  Header,
  Slider,
  Slide,
  Text,
} from "./styles/index.styled"

const ImageCarousel = ({ component }) => {
  if (!component) return null
  const { headingKicker, heading, subhead, link, images } = component

  return (
    <Section>
      <Wrapper>
        {headingKicker || heading ? (
          <Header>
            {headingKicker && <p className="heading-kicker">{headingKicker}</p>}
            {heading && <h2 className="heading">{heading}</h2>}
          </Header>
        ) : null}
        {images && images.length > 0 ? (
          <Slider>
            <Swiper
              spaceBetween={30}
              slidesPerView="auto"
              grabCursor
              keyboard
              loop
              speed={1000}
              autoplay={{
                delay: 2500,
              }}
            >
              {images?.map((img) => (
                <SwiperSlide key={img?.alt}>
                  <Slide>
                    <GatsbyImage
                      image={img?.desktop?.gatsbyImageData}
                      alt={img?.desktop?.alt}
                    />
                  </Slide>
                </SwiperSlide>
              ))}
            </Swiper>
          </Slider>
        ) : null}
        {subhead || link ? (
          <Text>
            {subhead && (
              <div
                className="subhead"
                dangerouslySetInnerHTML={{ __html: subhead }}
              />
            )}
            {link?.url && (
              <Button link={link?.url} isWithArrow variant="light-blue">
                {link?.label}
              </Button>
            )}
          </Text>
        ) : null}
      </Wrapper>
    </Section>
  )
}

export default ImageCarousel
